import type { SVGProps } from 'react';
const responsiveClockGenericTemplateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 0.75C18.2132 0.75 23.25 5.7868 23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM12 6C12.8284 6 13.5 6.67157 13.5 7.5V12C13.5 12.3978 13.342 12.7794 13.0607 13.0607L10.0607 16.0607C9.47487 16.6464 8.52513 16.6464 7.93934 16.0607C7.35355 15.4749 7.35355 14.5251 7.93934 13.9393L10.5 11.3775V7.5C10.5 6.70923 11.1119 6.06138 11.8881 6.00411L12 6Z"
      fill={props.color ?? 'black'}
    />
  </svg>
);
export default responsiveClockGenericTemplateOutline;
